import { useProductPageContext } from "@omni/components/components/ProductPage/context/productPage.context";
import { ProductPage } from "@omni/components/components/ProductPage/productPage";
import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { DamImage } from "@omni/components/utils/dam.utils";
import { cn } from "@omni/utils/styles";

type Props = {
    className?: string;
};

export const InfoCardsComponent = ({ className }: Props) => {
    const { t } = useGranite();

    const { infoCards, isEcochequesAccepted, isExclusivelyOnline, isWebOnly } =
        useProductPageContext();

    return (
        <div className={cn("tw:flex tw:flex-col tw:gap-4", className)}>
            {isEcochequesAccepted && (
                <ProductPage.InfoCard
                    className={cn(
                        "tw:border tw:border-grey tw:rounded-xl tw:p-4"
                    )}
                >
                    <ProductPage.InfoCard.Header>
                        <ProductPage.InfoCard.Header.Title>
                            {t("infoCard.ecoCheques.title")}
                        </ProductPage.InfoCard.Header.Title>
                        <ProductPage.InfoCard.Header.Icon
                            src={DamImage.icon.label.ecoCheques}
                            alt={t("infoCard.ecoCheques.iconAltText")}
                        />
                    </ProductPage.InfoCard.Header>
                    <ProductPage.InfoCard.Body>
                        <ProductPage.InfoCard.Body.Content>
                            {t("infoCard.ecoCheques.description")}
                        </ProductPage.InfoCard.Body.Content>
                        <ProductPage.InfoCard.Body.Link
                            href={infoCards.ecoChequeLink}
                        >
                            {t("infoCard.ecoCheques.linkLabel")}
                        </ProductPage.InfoCard.Body.Link>
                    </ProductPage.InfoCard.Body>
                </ProductPage.InfoCard>
            )}
            {isExclusivelyOnline && (
                <ProductPage.InfoCard
                    className={cn(
                        "tw:border tw:border-grey tw:rounded-xl tw:p-4"
                    )}
                >
                    <ProductPage.InfoCard.Header>
                        <ProductPage.InfoCard.Header.Title>
                            {t("infoCard.exclusivelyOnline.title")}
                        </ProductPage.InfoCard.Header.Title>
                        <ProductPage.InfoCard.Header.Icon
                            src={DamImage.icon.label.homeDelivery}
                            alt={t("infoCard.exclusivelyOnline.iconAltText")}
                        />
                    </ProductPage.InfoCard.Header>
                    <ProductPage.InfoCard.Body>
                        <ProductPage.InfoCard.Body.Content>
                            {t("infoCard.exclusivelyOnline.description")}
                        </ProductPage.InfoCard.Body.Content>
                        <ProductPage.InfoCard.Body.Link
                            href={infoCards.homeDeliveryLink}
                        >
                            {t("infoCard.exclusivelyOnline.linkLabel")}
                        </ProductPage.InfoCard.Body.Link>
                    </ProductPage.InfoCard.Body>
                </ProductPage.InfoCard>
            )}
            {isWebOnly && (
                <ProductPage.InfoCard
                    className={cn(
                        "tw:border tw:border-grey tw:rounded-xl tw:p-4"
                    )}
                >
                    <ProductPage.InfoCard.Header>
                        <ProductPage.InfoCard.Header.Title>
                            {t("infoCard.webOnly.title")}
                        </ProductPage.InfoCard.Header.Title>
                        <ProductPage.InfoCard.Header.Icon
                            src={DamImage.icon.label.webOnly}
                            alt={t("infoCard.webOnly.iconAltText")}
                        />
                    </ProductPage.InfoCard.Header>
                    <ProductPage.InfoCard.Body>
                        <ProductPage.InfoCard.Body.Content>
                            {t("infoCard.webOnly.description")}
                        </ProductPage.InfoCard.Body.Content>
                        <ProductPage.InfoCard.Body.Link
                            href={infoCards.webOnlyLink}
                        >
                            {t("infoCard.webOnly.linkLabel")}
                        </ProductPage.InfoCard.Body.Link>
                    </ProductPage.InfoCard.Body>
                </ProductPage.InfoCard>
            )}
        </div>
    );
};
